import { parseCustomDate as centralParseCustomDate } from '../../../../utils/dateUtils';

export const parseCustomDate = (dateStr) => {
    return centralParseCustomDate(dateStr);
};

export const getStatusDescriptor = (status, dueDate, completedDate, title, startDate, statusLabel, outcomeName, createdDate) => {
    const s = String(status || '').toLowerCase().trim();
    const sl = String(statusLabel || '').toLowerCase().trim();
    const on = String(outcomeName || '').toLowerCase().trim();

    if (s === 'converted' || sl === 'converted') {
        return 'Converted';
    }

    const isCompleted = s === 'completed' || s === 'closed' || s === '1291' || s === '1' ||
        sl === 'completed' || sl === 'closed' ||
        on.includes('done') || on.includes('completed');

    const dDateStr = (dueDate && !String(dueDate).startsWith('1900')) ? dueDate :
        ((startDate && !String(startDate).startsWith('1900')) ? startDate :
            ((createdDate && !String(createdDate).startsWith('1900')) ? createdDate : null));
    let cDateStr = completedDate || "";

    if (!cDateStr && title) {
        // Only extract if it looks like a valid date-title format YYYYMMDD
        const match = String(title).match(/(\d{4})(\d{2})(\d{2})/);
        if (match) {
            const y = parseInt(match[1], 10);
            const m = parseInt(match[2], 10);
            const d = parseInt(match[3], 10);
            // Strict validation before using as date
            if (y >= 2000 && y <= 2100 && m >= 1 && m <= 12 && d >= 1 && d <= 31) {
                cDateStr = match[0];
            }
        }
    }

    const dDate = parseCustomDate(dDateStr);
    const cDate = parseCustomDate(cDateStr);
    const now = new Date(); now.setHours(0, 0, 0, 0);

    if (isCompleted) {
        if (!dDate || !cDate) return 'Completed';
        const d1 = new Date(dDate); d1.setHours(0, 0, 0, 0);
        const d2 = new Date(cDate); d2.setHours(0, 0, 0, 0);
        const diffTime = d2.getTime() - d1.getTime();
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays === 0) return 'Completed On Same Day';
        if (diffDays < 0) return `Completed ${Math.abs(diffDays)} Day(S) Before Due Date`;
        return `Completed ${diffDays} Day(S) After Due Date`;
    }

    if (!dDate) return status || 'Open';

    const d1 = new Date(dDate); d1.setHours(0, 0, 0, 0);
    const diffTime = d1.getTime() - now.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) return `Overdue ${Math.abs(diffDays)} Day(S)`;
    if (diffDays === 0) return 'Due Today';
    return `Due In ${diffDays} Day(S)`;
};

export const formatDate = (dateString, includeTime = false) => {
    if (!dateString || (typeof dateString === 'string' && (dateString === "0" || dateString === "No Date" || dateString.startsWith('1900') || dateString === "0001-01-01T00:00:00"))) return '-';

    const date = parseCustomDate(dateString);
    if (!date || isNaN(date.getTime())) {
        return '-';
    }

    const day = String(date.getDate()).padStart(2, '0');
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    if (!includeTime) return `${day}-${month}-${year}`;

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
}


export const TASK_ACTIONS = [
    { id: 'followup', icon: 'ri:user-follow-line', label: 'Add Followup', color: '#4caf50' }, // Green
    { id: 'send-mail', icon: 'ri:mail-send-line', label: 'Send Mail', color: '#f44336' }, // Red
    { id: 'send-sms', icon: 'ri:chat-1-line', label: 'Send SMS', color: '#2196f3' }, // Blue
    { id: 'send-voice', icon: 'ri:mic-line', label: 'Send Voice', color: '#9c27b0' }, // Purple
    { id: 'add-notes', icon: 'ri:sticky-note-line', label: 'Add Note', color: '#ff9800' }, // Orange
    { id: 'upload-document', icon: 'ri:upload-cloud-2-line', label: 'Upload Document', color: '#00bcd4' }, // Cyan
    { id: 'add-task', icon: 'ri:task-line', label: 'Add Task', color: '#3f51b5' }, // Indigo
    { id: 'add-appointment', icon: 'ri:calendar-event-line', label: 'Add Appointment', color: '#e91e63' }, // Pink
    { id: 'add-deal', icon: 'ri:hand-coin-line', label: 'Add Deal', color: '#8bc34a' }, // Light Green
    { id: 'fill-webform', icon: 'ri:article-line', label: 'Fill Webform', color: '#607d8b' } // Blue Grey
];
